import { TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  format1Decimal,
  format2Decimal,
  formatComma,
  formatMoney,
  openNOC,
} from '../../utils';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const LightTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#FFFCD1',
    color: 'rgba(0, 0, 0, 0.9)',
    fontSize: 11,
  },
}))(Tooltip);

const TableRowCells = ({ row, styles, window, myKey, setStateAction }) => {
  return (
    <TableRow
      key={myKey}
      style={
        myKey % 2
          ? {
              background: '#e5e5e5',
              height: '25px',
            }
          : { background: 'white', height: '25px' }
      }
    >
      {window.innerWidth > 1500 && (
        <TableCell
          style={{
            ...styles.rowCell,
            width: '200px',
            maxWidth: '200px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {row.CompanyName}
        </TableCell>
      )}

      {/* Ticker */}
      <TableCell style={styles.rowCell} align="left">
        <Link
          onClick={() => openNOC(row.Symbol)}
          style={{ color: 'blue' }}
          to="/stocks"
          // target="_blank"
        >
          {row.Symbol}
        </Link>
      </TableCell>
      {/* Price */}
      <TableCell style={styles.rowCell} align="right">
        ${formatMoney(row.spot)}
      </TableCell>
      {/* Chg */}
      <TableCell style={styles.rowCell} align="right">
        <span style={row.spotchg > 0 ? { color: 'green' } : { color: 'red' }}>
          {format2Decimal(row.spotchg)}
        </span>
      </TableCell>
      {/* Chg %*/}
      <TableCell style={styles.rowCell} align="right">
        <span
          style={row.spotchgpct > 0 ? { color: 'green' } : { color: 'red' }}
        >
          {row.spotchgpct ? format1Decimal(row.spotchgpct) : ''}%
        </span>
      </TableCell>
      {/* mkt cap */}
      <TableCell style={styles.rowCell} align="center">
        {row['mkt']}
      </TableCell>
      {/* earnings */}
      <TableCell style={styles.rowCell} align="center">
        {row.earningObject.date}
      </TableCell>
      {row.divdate === '' && (
        <TableCell
          style={{
            ...styles.rowCellEdge,
            color: 'red',
            width: '20px',
          }}
          align="center"
        >
          {row.div}
        </TableCell>
      )}
      {row.divdate !== '' && (
        <LightTooltip placement="bottom" title={'Dividend : ' + row.divdate}>
          <TableCell
            style={{
              ...styles.rowCellEdge,
              color: 'red',
              width: '20px',
            }}
            align="center"
          >
            {row.div}
          </TableCell>
        </LightTooltip>
      )}

      {/* volumne */}

      <TableCell
        style={{
          ...styles.clickableCell,
          textAlign: 'end',
        }}
        className="toggleCell"
        align="right"
      >
        <Link
          onClick={() =>
            setStateAction({
              isVolClicked: true,
              modalRowData: row,
            })
          }
          style={{
            ...styles.removeUnderline,
            padding: '5px',
          }}
        >
          {' '}
          {formatComma(row.volume)}{' '}
        </Link>
      </TableCell>

      {/* calls */}
      <TableCell style={styles.rowCell} align="right">
        {row.calls + '%'}
      </TableCell>
      {/* puts*/}
      <TableCell style={styles.rowCell} align="right">
        {row.puts + '%'}
      </TableCell>
      {/* RV*/}
      <TableCell style={styles.rowCell} align="right">
        <strong>{format1Decimal(row.RV)}</strong>
      </TableCell>
      {/* IV*/}

      <TableCell style={styles.rowCell} align="right">
        {format1Decimal(row.IV * 100)}
      </TableCell>
      {/* CHG*/}

      <TableCell
        style={{
          ...styles.rowCell,
          width: '25px',
          borderRight: 'none',
        }}
        align="right"
      >
        <span style={row.atmchg > 0 ? { color: 'green' } : { color: 'red' }}>
          {row.atmchg > 0
            ? '+' + format1Decimal(row.atmchg * 100)
            : format1Decimal(row.atmchg * 100)}
        </span>
      </TableCell>
    </TableRow>
  );
};
export default TableRowCells;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/tableRowCells.jsx